import { render, staticRenderFns } from "./selectGradeModal.vue?vue&type=template&id=5becf4da&scoped=true&"
import script from "./selectGradeModal.vue?vue&type=script&lang=js&"
export * from "./selectGradeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5becf4da",
  null
  
)

export default component.exports